
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "ContentFallback",
  setup() {
    const store = useStore();

    const isLoading = computed(() => store.getters["loading_module/isLoading"]);

    return { isLoading };
  }
});
